import { useParams } from "react-router";
import { MainPadding } from "../../../../styles/Main.styles";
import { useGetPurchaseInvoice } from "../../api/invoice/purchase/resolver";
import Spinner from "../../../../components/spinner/Spinner";
import { Box, Typography } from "@mui/material";
import FormLunas from "../../form/pembelian/lunas/Form";
import FormBelumLunas from "../../form/pembelian/belumLunas/Form";
import FormAdd from "../../form/pembelian/add/Form";

export default function CreationPembelian() {
  const { idPurchaseInvoice } = useParams();
  const { data: dataRawDetailInvoice, isLoading } = useGetPurchaseInvoice({
    purchase_invoice_id: idPurchaseInvoice,
  });
  const dataDetailInvoice = dataRawDetailInvoice?.data.data;

  if (!idPurchaseInvoice) {
    return (
      <MainPadding>
        <FormAdd />
      </MainPadding>
    );
  }

  if (idPurchaseInvoice && isLoading) {
    return (
      <MainPadding>
        <Spinner />
      </MainPadding>
    );
  }

  if (dataDetailInvoice === undefined) {
    return (
      <MainPadding>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"100%"}
        >
          <Typography>Data Invoice Pembelian Tidak Ditemukan</Typography>
        </Box>
      </MainPadding>
    );
  }

  return (
    <MainPadding>
      {dataDetailInvoice.status.toString() === "2" ? (
        <FormLunas dataInvoice={dataDetailInvoice} />
      ) : (
        <FormBelumLunas dataInvoice={dataDetailInvoice} />
      )}
    </MainPadding>
  );
}
